import { useDispatch } from "react-redux"
import { detailsActions } from "../../../../store/details"
import { useNavigate } from "react-router-dom"

import classes from './GoToDetailsTab.module.css'

export default function GoToDetailsTab({children, tabNumber, workqSlug, caseId}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(tabNumber))
        navigate(`/work-queues/${workqSlug}/${caseId}`)
    }

    return <button onClick={openTabHandler} className={classes.button}>
        {children}
    </button>
}